<template>
  <div class="card">
    <div class="card-header d-flex align-items-center py-0">
      <h4 class="py-3 mb-0">Contatos</h4>
      <span class="text-muted ms-2 d-none d-sm-none d-md-block">
        Confira os contatos sincronizados com o Ninja
      </span>
      <div class="ms-auto my-auto">
        <button
          type="button"
          class="btn btn-primary"
          title="Sincronizar Contatos"
          :disabled="isSyncingContacts"
          @click="syncContacts"
        >
          <span v-if="isSyncingContacts">
            <i class="ph ph-spinner spinner me-2" /> Realizando Sincronização
          </span>
          <span v-else>Sincronizar Contatos</span>
        </button>
      </div>
    </div>
    <LoadingData v-if="isLoadingData" class="my-3" />
    <ListContacts v-else :contacts="contacts" />
  </div>
</template>

<script>
import LoadingData from '@/components/commons/LoadingData.vue'
import ListContacts from '@/components/registers/contacts/ListContacts.vue'

export default {
  name: 'Contacts',

  components: {
    LoadingData,
    ListContacts,
  },

  data() {
    return {
      isLoadingData: true,
      isSyncingContacts: false,
      contacts: [],
    }
  },

  methods: {
    async getContacts() {
      try {
        this.isLoadingData = true
        this.contacts = await this.$store.dispatch('getContacts')
        this.isLoadingData = false
      } catch (error) {
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },

    async syncContacts() {
      try {
        this.isSyncingContacts = true

        const response = await this.$store.dispatch('syncContacts')
        this.$root.$refs.notification.success(response.message)

        this.isSyncingContacts = false
        this.getContacts()
      } catch (error) {
        this.isSyncingContacts = false
        if (error && error.message) {
          this.$root.$refs.notification.warning(error.message)
        } else {
          this.$root.$refs.notification.error(
            'Não foi possível se conectar ao servidor.',
          )
        }
      }
    },
  },

  mounted() {
    this.getContacts()
  },
}
</script>
